import { useTranslation } from 'react-i18next';

import type { Classification } from '@/signalr';
import { ClassificationPanelItem, type ClassificationItem } from '../ClassificationPanelItem';

export type CallerClassificationPanelProps = {
  classification: Classification | null;
};

export function CallerClassificationPanel({ classification }: CallerClassificationPanelProps) {
  const { t } = useTranslation();

  const items: ClassificationItem[] = [];
  const classificationItem = (title: string, image: string): ClassificationItem => ({
    title,
    image: `Images/Incident/Classification/${image}`,
  });

  if (classification != null) {
    if (classification.hardInjury) {
      items.push(classificationItem(t('Incident_InfoPanel_Classification_HardInjury_Label'), 'hard-injury.svg'));
    }
    if (classification.carAccident) {
      items.push(classificationItem(t('Incident_InfoPanel_Classification_CarAccident_Label'), 'car-accident.svg'));
    }
    if (classification.heartIssue) {
      items.push(classificationItem(t('Incident_InfoPanel_Classification_HeartIssue_Label'), 'heart-issue.svg'));
    }
    if (classification.bleeding) {
      items.push(classificationItem(t('Incident_InfoPanel_Classification_Bleeding_Label'), 'bleeding.svg'));
    }
    if (classification.allergic) {
      items.push(classificationItem(t('Incident_InfoPanel_Classification_Allergic_Label'), 'allergic-reaction.svg'));
    }
    if (classification.breathingIssue) {
      items.push(classificationItem(t('Incident_InfoPanel_Classification_BreathingIssue_Label'), 'breathing-issue.svg'));
    }
    if (classification.otherProblem) {
      items.push(classificationItem(t('Incident_InfoPanel_Classification_Other_Label'), 'other-problem.svg'));
    }
    if (classification.unconsciousness) {
      items.push(classificationItem(t('Incident_InfoPanel_Classification_Unconsciousness_Label'), 'unconsciousness.svg'));
    }
    if (classification.witness) {
      items.push(classificationItem(t('Incident_InfoPanel_Classification_Witness_Label'), 'witness.svg'));
    }
    if (classification.avalanche) {
      items.push(classificationItem(t('Incident_InfoPanel_Classification_Avalanche_Label'), 'avalanche.svg'));
    }
    if (classification.deadlock) {
      items.push(classificationItem(t('Incident_InfoPanel_Classification_Deadlock_Label'), 'deadlock.svg'));
    }
    if (classification.lost) {
      items.push(classificationItem(t('Incident_InfoPanel_Classification_Lost_Label'), 'lost.svg'));
    }
    if (classification.mountainInjury) {
      items.push(classificationItem(t('Incident_InfoPanel_Classification_MountainInjury_Label'), 'mountain-injury.svg'));
    }
  }

  return <ClassificationPanelItem items={items} />;
}
